module.exports = __webpack_public_path__ + "DINNextLTPro-Medium.woff?02f5e64f1788a412d2c02dce5a931ec2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Medium.woff
// module id = 1380
// module chunks = 0